import React from 'react'

const React_Coding_Practice_1 = () => {
  return (
    <div>
      <h1>Coding Practice 1</h1>
    </div>
  )
}

export default React_Coding_Practice_1
